import { render, staticRenderFns } from "./ButtonSecondaryAction.vue?vue&type=template&id=e9ff521e&scoped=true&"
import script from "./ButtonSecondaryAction.vue?vue&type=script&lang=js&"
export * from "./ButtonSecondaryAction.vue?vue&type=script&lang=js&"
import style1 from "./ButtonSecondaryAction.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9ff521e",
  null
  
)

export default component.exports